/*===============================================================

	load event

===============================================================*/

$(window).on('load', function(){
  countDown();
  set_image_caption();
});



/*===============================================================

	top scroll section

===============================================================*/

function locomotiveScroll() {
  
    if(!$('html').hasClass('has-scroll-smooth')) {

      document.documentElement.classList.add('is-loaded');
      document.documentElement.classList.remove('is-loading');

      setTimeout(() => {
          document.documentElement.classList.add('is-ready');
      },300)

      let options = {
          el: document.querySelector('[data-scroll-container]'),
          smooth: true,
          getSpeed: true,
          getDirection: true
      }

      if($('[data-scroll-container]').length>0) {
        if(document.querySelector('[data-scroll-container]').getAttribute('data-horizontal') == 'true') {
            options.direction = 'horizontal';
            options.gestureDirection = 'both';
            options.tablet = {
                smooth: true,
                direction: 'horizontal',
                horizontalGesture: true
            }
            options.smartphone = {
                smooth: false,
                horizontalGesture: false
            }
            options.reloadOnContextChange = true
        }

        setTimeout(() => {
            const scroll = new LocomotiveScroll(options);

            let dynamicBackgrounds = [];
            let dynamicColorElements = [];
        
        	$(document).on('click', 'a[href*="#"]', function() {
              var href= $(this).attr("href");
              target = $(href == "#" || href == "" ? 'html' : href);
              console.log(target);
              scroll.scrollTo(target);
            });
        
        	

            scroll.on('scroll', (instance) => {

              //console.log(instance.delta.x);

              //$('.contents-header').css('transform','translateX(-'+instance.delta.x+'px)');
              //$('.contents-footer').css('transform','translateX(-'+instance.delta.x+'px)');
                /*const progress = 360 * instance.scroll.y / instance.limit.y;


                scroll.el.style.backgroundColor = `hsl(${progress}, 11%, 81%)`;

                dynamicBackgrounds.forEach(obj => {
                    obj.el.style.backgroundColor = `hsl(${progress}, 11%, 81%)`;
                });
                dynamicColorElements.forEach(obj => {
                    obj.el.style.color = `hsl(${progress}, 11%, 81%)`;
                });

                document.documentElement.setAttribute('data-direction', instance.direction)*/

            });

           

        }, 1000);
      }
    }
}


/*===============================================================

	resize event

===============================================================*/

$(window).on('load resize', function(){
	
	w_width = $(window).width();
	w_height = $(window).height();
	header_h = $('.contents-header').outerHeight();


	footer_position();
	
	if( w_width < 769 ) {
		$('.contents-main').attr('style','');
    
		// set gnav triggers
    $('.gnav').each(function(index){
      if($(document).find('.gnav-trigger').length < 1) {
        $('.gnav').before('<div class="gnav-trigger"><span class="label"></span></div>');
      }
    });	
	}
	else {
    	//locomotiveScroll();
		$('.gnav.active').remove('active');
		modal_close();
    
		if($(document).find('.gnav-trigger').length > 0) {   
			$(document).find('.gnav-trigger:not(.hold)').remove();
		}
    
	}
  
    if($('.menu-item .col').length > 0) {
      if(w_width < 769) {
        $('.menu-item:not(.slick-slider)').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 1000,
          dots: true,
          arrows: false,
          infinite: false,
          variableWidth: true,
          infinite: true,
          centerMode: true,
          responsive: [
          {
              breakpoint: 768,
          }]
        });
      }
      else {
        $('.menu-item.slick-initialized').slick('unslick');
      }
    }
	
});



/*===============================================================

	scroll event

===============================================================*/
w_width = $(window).width();
$(window).on('load scroll', function(){
	
	scrollTop = $(window).scrollTop();
  

  if( 1 < scrollTop && $('.countdown_area').length>0 ) {
    $('.countdown_area').fadeOut(400);
  }
  else {
    $('.countdown_area').fadeIn(400);
  }
  
  
  
  if($('.journal-list .billboard').length > 0) {
    
    title_h = $('.page-title').height();
    padding = 60;
    if(w_width < 769) {
      padding = 0;
    }
    
    
    if(scrollTop < title_h + padding) {
      	if(w_width < 769) {
			$('.journal-list .page-title').css('transform', 'translateY('+scrollTop*0.75+'px)');
        }
      
    	$('.journal-list .billboard').css('margin-top', '-'+scrollTop+'px');
  	}
    
    if( title_h <= scrollTop) {
        $('.page-title').addClass('active');
      }
      else {
        $('.page-title').removeClass('active');
      }
  }
 	 
  
  //console.log(scrollTop);
});




/*===============================================================

	# anchor

===============================================================*/


$(document).on('click', 'a[href*="#"]', function() {
	
	delay = 0;
  	header_h = 0;
  	var speed = 400;
  	var href= $(this).attr("href");
  	name = href.replace('#', '');
  	target = $(href == "#" || href == "" ? 'html' : href);

	w_width = $(window).width();
	if(w_width < 769 ) {
		modal_close();
		$('html,body').attr('style','');
		$('html,body').scrollTop(scroll_top);
      
      	//setTimeout(function(){
          header_h = $('.contents-header').height();
          position = target.offset().top - header_h + 100;
          $('body,html').animate({scrollTop:position}, speed, 'swing');
        //},40);
	}
  else {
   
    /*if( $('.contents-wrapper').hasClass('top') && $(this).parents('nav').hasClass('gnav') ){
      target = href.slice( 1 );
     // $('scrollbtn').find('.'+target)[0].click();
      console.log('ok');
      $('.'+target)[0].click();
    }*/
      
    /*position = target.offset().left * -1;
    console.log(target.offset());
    
    $('html').addClass('has-scroll-smooth');
    
    $('[data-scroll-container] [data-scroll-section]').css('transform', 'matrix3d(1, 0, 0.00, 0, 0.00, 1, 0.00, 0, 0, 0, 1, 0,' + position +', 0, 0, 1)');
    
    window.scrollBy( target.offset().left, 0 );*/
  }
  

});


/*===============================================================

	footer position

===============================================================*/

function footer_position(delay_flg) {
	
	if(delay_flg == true)	delay = 0;
	else 									delay = 401;

	window_h = $(window).height();
	contents_h = 0;
  
	if($('.main-left').length>0) {
		$('.contents-main').height($('.main-right').outerHeight());
		if($('.main-left').outerHeight() > $('.main-right').outerHeight())	$('.contents-main').height($('.main-left').outerHeight());
	}
	
	
	setTimeout(function(){
		
		$('.contents-wrapper > *').each(function(i) {
			contents_h += $(this).outerHeight();
		});
		
		if(window_h > contents_h) {
			$('.contents-footer').addClass('position_bottom');
		}
		else {
			$('.contents-footer').removeClass('position_bottom');
		}
	},delay);

}


/*===============================================================

	gnav

===============================================================*/

$(document).on('click', '.gnav-trigger', function(){
	if(!$(document).find('.gnav').hasClass('active')) {
		
		modal_close();
    window_lock();
		$(document).find('.gnav').addClass('active');
		$(this).addClass('active');
    $('.contents-wrapper').addClass('modal-gnav');
		
	}
	else {
		modal_close();	
	}
});


$(document).on('click', '.gnav .list .parent', function() {
  
  w_width = $(window).width();
	if(w_width < 769 ) {
    if(!$(this).hasClass('active')) {
      $(this).addClass('active');
    }
    else {
      $(this).removeClass('active');
    }
  }
  
});



/*===============================================================

	pagination

===============================================================*/

$(document).on('change', '[name="pagination"]', function() {
	link = $(this).children('option:selected').val();
	location.href = link;
});



/*===============================================================

	fade section

===============================================================*/

function doFade(hide,show) {
		$(document).find('#'+hide+'.fade').removeClass('active');
		$(document).find('#'+show+'.fade').addClass('active');
}



/*===============================================================

	accordion section

===============================================================*/

$(document).on('click', '[class*= "accordion"]', function() {
  w_width = $(window).width();
  index = $('[class*= "accordion"]').index(this);
  
  if(w_width > 769 && $(this).hasClass('accordion-sp') ){}
  else if(w_width < 769 && $(this).hasClass('accordion-pc')){}
  else  accordion(index);
});

function accordion(index) {
  if($('[class*= "accordion"]').eq(index).hasClass('active')) {
    $('[class*= "accordion"]').eq(index).removeClass('active');
  }
  else{
    $('[class*= "accordion"]').eq(index).addClass('active');
  }
}

$(document).on('click', '.address .accordion_close', function() {
  $(this).parents('.address').find('[class*= "accordion"]').removeClass('active');
});



/*===============================================================

	form controle

===============================================================*/

/*---------------------------------------------------------------
	select
---------------------------------------------------------------*/

$(document).on('change', '.form.type-select select', function(){
	value = $(this).find('option:selected').text();
	$(this).parent('.form.type-select').find('.label').text(value);
});


/*---------------------------------------------------------------
	cancel
---------------------------------------------------------------*/

$(document).on('click', '.form-cancel', function(){
  form_id = $(this).parents('form').attr('id');
  $('#'+form_id)[0].reset();
  $('#'+form_id).find('.form.type-select').find('.label').text('選択する');
});


/*---------------------------------------------------------------
	check form val
---------------------------------------------------------------*/

$(document).on('change blur', '.form-check input, .form-check select, .form-check textarea', function() {
	
	check_count = 0;

	$(this).parents('.form-check').find('[class^="required"],[class*=" required"]').each(function(index, element){
		document_name = $(this).prop('tagName');
		from_name = $(this).attr('name');
		alert_val = '';

		alert_val = check_from_val(document_name, from_name);
		if(alert_val !== '')	check_count++;
	});


	//append alert
	if($(this).is('[class^="required"],[class*=" required"]')) {
		alert_val = check_from_val($(this).prop('tagName'), $(this).attr('name'));
		$(this).parents('.alert-area').find('.alert').remove();
		if(alert_val !== ''){
			if($(this).parents('.alert-area').find('.alert').length < 1){
				$(this).parents('.alert-area').append('<span class="alert">'+alert_val+'</span>');
			}
		}
		else {
			if($(this).parents('.alert-area').find('.alert').length > 0){
				$(this).parents('.alert-area').find('.alert').remove();
			}
		}
	}

	//show next btn
	//if(check_count < 1 && $('[name="agreement"]').prop('checked')) $('#preview.btn').removeClass('disabled');
  if(check_count < 1 ) $('#preview.btn').removeClass('disabled');
	else	$('#preview.btn').addClass('disabled');
		
});


function check_from_val(document_name, from_name) {
	
	from_name = '[name="'+from_name+'"]';
	alert_val　= '';
	
	if(document_name == 'INPUT') {
			switch($(from_name).attr('type')) {
				case 'text':
				case 'password':
				case 'number':
					if($(from_name).val() == '') alert_val = 'default';
					
					//mail
					if($(from_name).hasClass('required-mail')) {
						if(!$(from_name).val().match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/))	alert_val = 'メールアドレスの形式ではありません';
						if($('#mailaddress').val() !== $('#mailaddress-2').val())	alert_val = '２つのメールアドレスが異なります';
					}
					
					//tel
					if($(from_name).hasClass('required-tel')) {
						if($('#mobile').val() == '' && $('#tel').val() == '')	alert_val = 'どちらか必ず入力してください';
						else if($('#mobile').val() == '' || $('#tel').val() == '')	alert_val = '';
					}
					break;
				case 'checkbox':
					if($(form_name+':checked').length < 1) alert_val = 'default';
					break;
				case 'radio':
					if($(form_name+':checked').length < 1 || $(form_name+':checked').val() == false) alert_val = 'default';
					break;
			}	
			form_name = '';
		}
		if(document_name == 'SELECT') {
			if($(from_name+':visible').find('option:selected').val() == '' ) alert_val = 'default';
		}
		if(document_name == 'TEXTAREA') {
			if($(from_name).val() == '') alert_val = 'default';
		}
	
		if(alert_val === 'default')	alert_val = '必須項目です';	
		return alert_val;
}


$(document).on('change blur', 'input, select, textarea', function() {
	value = $(this).val();
	if($(this).prop('disabled') == false) {
		if($(this).attr('type') == 'text' ||  $(this).attr('type') == 'number' || $(this).attr('type') == 'password') {
			value = $(this).val();
		}
		if($(this).prop("tagName").match(/select/i)) {
			//value = $(this).find('option:selected').val();
      value = $(this).find('option:selected').text();
		}
		if($(this).attr('type') == 'radio') {
			value = $(this).val();
		}
		select_name = '.'+$(this).attr('name');
		
		//console.log($(this).attr('name')+'/'+$(this).attr('class'));

		/*if($('.form.type-pre'+select_name).length > 0) {
			$('.form.type-pre'+select_name).text(value);
		}*/
	}
	
});

/*===============================================================

	modal

===============================================================*/

/*---------------------------------------------------------------
	window lock
---------------------------------------------------------------*/

function window_lock() {
	$('html').css({'position':'fixed','width':'100%','top':-$(window).scrollTop()});
}

function window_default() {
	window_style = $('html').attr('style');
	
	if(typeof(window_style) != "undefined") {
		scroll_top = Math.abs(parseInt($('html').css('top')));
		if(scroll_top>=0) {
			$('html').attr('style','');
			$(window).scrollTop(scroll_top);
		}
	}
}


/*---------------------------------------------------------------
	modal close
---------------------------------------------------------------*/

function modal_close() {
	window_default();
	$(document).find('.gnav').removeClass('active');
	$(document).find('.gnav-trigger').removeClass('active');
  
    $('[class^="modal-"]').remove();
    $('.contents-wrapper').removeClass('modal');
    $('.contents-wrapper').removeClass('modal-gnav');
}

$(document).on('click', '.modal-bg, .modal-close, .gnav-close', function() {
	modal_close();
});


/*===============================================================

	count down

===============================================================*/

function countDown() {
  
  if($(".countdown").length>0) {
    var startDateTime = new Date();
    var endDateTime = new Date("July 07,2021 10:00:00");
    var left = endDateTime - startDateTime;
    var a_day = 24 * 60 * 60 * 1000;

  // 期限から現在までの『残時間の日の部分』
    var d = Math.floor(left / a_day) 

  // 期限から現在までの『残時間の時間の部分』
    var h = Math.floor((left % a_day) / (60 * 60 * 1000)) 

  // 残時間を秒で割って残分数を出す。
  // 残分数を60で割ることで、残時間の「時」の余りとして、『残時間の分の部分』を出す
    var m = Math.floor((left % a_day) / (60 * 1000)) % 60;
    m = ( '00' + m ).slice( -2 );

  // 残時間をミリ秒で割って、残秒数を出す。
  // 残秒数を60で割った余りとして、「秒」の余りとしての残「ミリ秒」を出す。
  // 更にそれを60で割った余りとして、「分」で割った余りとしての『残時間の秒の部分』を出す
    var s = Math.floor((left % a_day) / 1000) % 60 % 60
    
    
    if( startDateTime < endDateTime) {
      $(".countdown").text(d + 'days ' + h + ':' + m );
      $(".countdown_area").show();
      //setTimeout('countDown()', 1000);
    }
  }
}


/*===============================================================

	count down

===============================================================*/

function set_image_caption() {
  
  $('.post-content img').each(function(index){
    alt = $(this).attr('alt');
    if( alt != undefined ) {
      $(this).after('<span class="caption">'+alt+'</span>');
       }
  });
}